import { logWrapper } from '../utils';
import jQuery from 'jquery';

function ddv4FixedHeaderDirectiveFactory(runtimeConstant, $timeout) {
  function link(scope, element) {

    $timeout(() => {
      if (!window.jQuery) {
        return;
      }

      scope.$watch('trigger', function () {
        const raw = element[0];

        if (!raw) return;

        const table = jQuery('#documents');

        jQuery(raw).css('width', jQuery(table).width());
        jQuery(raw).css('display', 'block');

        jQuery(window).on('resize', function () {
          const watch = jQuery('#documents');
          jQuery(raw).css('width', jQuery(watch).width());
        });
      });
    }, 1000);
  }

  function run() {
    return {
      restrict: 'A',
      scope: {
        trigger: '@ddv4FixedHeader',
      },
      link: link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const ddv4FixedHeaderDirective = ['runtimeConstant', '$timeout', ddv4FixedHeaderDirectiveFactory];